module.exports = __webpack_public_path__ + "resource/img/noUserAva.c5f2c49e.png";